<template>
  <a-config-provider :theme="theme"><RouterView /></a-config-provider>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { theme as antTheme } from 'ant-design-vue';
import { applyLocalTheme, getLocalTheme, type LocalTheme } from '../../design-system/theme';

const localTheme = ref<LocalTheme>('system');
const resolvedTheme = ref<'light' | 'dark'>('light');
const apply = (): void => { resolvedTheme.value = applyLocalTheme(localTheme.value); };
const onThemeChange = (event: Event): void => {
  const value = (event as CustomEvent<LocalTheme>).detail;
  if (value === 'light' || value === 'dark' || value === 'system') { localTheme.value = value; apply(); }
};
const onSystemChange = (): void => { if (localTheme.value === 'system') apply(); };
const theme = computed(() => ({ algorithm: resolvedTheme.value === 'dark' ? antTheme.darkAlgorithm : antTheme.defaultAlgorithm, token: { colorPrimary: resolvedTheme.value === 'dark' ? '#8B82F1' : '#6657E8', colorLink: resolvedTheme.value === 'dark' ? '#8B82F1' : '#6657E8', borderRadius: 8 } }));
onMounted(() => { localTheme.value = getLocalTheme('ai-workspace.admin.theme'); apply(); window.addEventListener('ai-admin-theme', onThemeChange); window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', onSystemChange); });
onBeforeUnmount(() => { window.removeEventListener('ai-admin-theme', onThemeChange); window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', onSystemChange); });
</script>
